import { ModalV2 } from 'components';
import { formatLocale, titleToLocaleKey } from 'lib';
import { useTranslation } from 'react-i18next';

const CancelView = ({ visible, closeModal, sub, isMobile, cancelReason, setCancelReason, onCancel, onBack }) => {
    const { t } = useTranslation();
    if (!sub) return null;

    return (
        <ModalV2 visible={visible} closeModal={closeModal} width={isMobile ? 'calc(100% - 32px)' : '480px'}>
            <div className="p-6 space-y-5">
                <h3 className="text-lg font-bold text-gray-900 font-[CeraPro]">
                    {t('billing.cancelSubscription')}
                </h3>

                <p className="text-sm text-gray-500 font-[CeraPro] leading-relaxed">
                    {t('billing.cancelConfirmation', {
                        plan: t(`subscription.plans.${titleToLocaleKey(sub.planTitle)}`, { defaultValue: sub.planTitle }),
                        team: sub.teamName,
                        date: formatLocale(sub.currentPeriodEnd, 'MMM d, yyyy')
                    })}
                </p>

                <div className="space-y-1.5">
                    <label className="text-xs text-gray-400 font-[CeraPro]">
                        {t('billing.cancelReasonLabel')}
                    </label>
                    <textarea
                        className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm font-[CeraPro] resize-none focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-300 placeholder:text-gray-300 transition-shadow"
                        rows={3}
                        placeholder={t('billing.cancelReasonPlaceholder')}
                        value={cancelReason}
                        onChange={(e) => setCancelReason(e.target.value)}
                    />
                </div>

                <div className="flex gap-3 pt-1">
                    <button
                        onClick={onBack}
                        className="flex-1 h-11 rounded-full border-2 border-black text-sm font-bold font-[CeraPro] hover:opacity-80 active:scale-[0.98] transition-all"
                    >
                        {t('billing.goBack')}
                    </button>
                    <button
                        onClick={onCancel}
                        className="flex-1 h-11 rounded-full bg-[#FA3F58] text-white text-sm font-bold font-[CeraPro] hover:opacity-80 active:scale-[0.98] transition-all"
                    >
                        {t('billing.cancelSubscription')}
                    </button>
                </div>
            </div>
        </ModalV2>
    );
};

export default CancelView;
